import { render } from "./Navigation.vue?vue&type=template&id=a476347c&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=a476347c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a476347c"

export default script